import { DropdownItem } from 'components/dropdown/dropdown-item';

export const initialASBVsColumns: DropdownItem[] = [
  {
    id: '',
    value: '',
  },
  {
    id: '',
    value: '',
  },
  {
    id: '',
    value: '',
  },
  {
    id: '',
    value: '',
  },
  {
    id: '',
    value: '',
  },
  {
    id: '',
    value: '',
  },
  {
    id: '',
    value: '',
  },
  {
    id: '',
    value: '',
  },
];
